import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { isEmpty } from 'validate.js';

import SmartImage from 'dpl/components/SmartImage';

import amexBrandSvg from 'dpl/assets/payment_methods/card_brands/amex.svg';
import dinersBrandSvg from 'dpl/assets/payment_methods/card_brands/diners.svg';
import discoverBrandSvg from 'dpl/assets/payment_methods/card_brands/discover.svg';
import jcbBrandSvg from 'dpl/assets/payment_methods/card_brands/jcb.svg';
import mastercardBrandSvg from 'dpl/assets/payment_methods/card_brands/mastercard.svg';
import unionpayBrandSvg from 'dpl/assets/payment_methods/card_brands/unionpay.svg';
import visaBrandSvg from 'dpl/assets/payment_methods/card_brands/visa.svg';

const CARD_BRAND_IMAGES = {
  amex: amexBrandSvg,
  diners: dinersBrandSvg,
  discover: discoverBrandSvg,
  jcb: jcbBrandSvg,
  mastercard: mastercardBrandSvg,
  unionpay: unionpayBrandSvg,
  visa: visaBrandSvg
};

/*
  Styles for this component are included in this SCSS partial:
  app/assets/stylesheets/partials/_payment_method_form.scss
*/

export default function PaymentMethodOption({
  active,
  paymentMethod,
  className,
  onClick
}) {
  const {
    account_holder: accountHolder,
    brand_name: brandName,
    last4,
    funding,
    account_type: accountType
  } = paymentMethod;

  const cardBrandImage = CARD_BRAND_IMAGES[brandName];

  return (
    <button
      type="button"
      className={classnames('PaymentMethodOption', className)}
      onClick={onClick}
    >
      <div className="PaymentMethodOption__radio-icon">
        {active && <span className="PaymentMethodOption__radio-icon__fill" />}
      </div>
      {isEmpty(paymentMethod) ? (
        <span className="PaymentMethodOption__new">Add new payment method</span>
      ) : (
        <div className="PaymentMethodOption__content">
          <div className="PaymentMethodOption__info">
            <div className="PaymentMethodOption__account-details">
              {cardBrandImage && (
                <SmartImage
                  className="PaymentMethodOption__brand-image"
                  src={cardBrandImage}
                />
              )}
              {[brandName, funding, accountType?.split('_')]
                .filter(Boolean)
                .join(' ')}
            </div>
            {accountHolder && (
              <span className="PaymentMethodOption__account-holder">
                {accountHolder}
              </span>
            )}
          </div>
          <span className="PaymentMethodOption__last-4">****&nbsp;{last4}</span>
        </div>
      )}
    </button>
  );
}

PaymentMethodOption.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  paymentMethod: PropTypes.shape({
    brand_name: PropTypes.string,
    last4: PropTypes.string,
    account_holder: PropTypes.string,
    account_type: PropTypes.string,
    funding: PropTypes.string
  })
};

PaymentMethodOption.defaultProps = {
  active: false,
  className: '',
  onClick: null,
  paymentMethod: {}
};
